import React from 'react';
import { useSelector } from 'react-redux';
import languageConstants from '../shared/appConfig/languageConstants';
import { currencyUtils } from '../shared/utilities/currencyUtils';
import { showNumberOfDrivers, pluralSuffix } from '../shared/utilities/general';
import globalConstants from '../shared/appConfig/globalConstants';
import { WhatsNeededUIType, NoOfDrivers } from '../shared/appConfig/enums';

const { Pallet: PALLET_LABEL } = globalConstants.PageLabels;
const { SOLO } = NoOfDrivers;

const Summary = ({editBungii,whatsNeededData,state}) => {
    const {
      pickupAdd,
      dropoffAdd,
      deliveryTime,
      distance,
      partnerUpchargeValue,
      isMuscleHelpRequired,
      tripType,
      estimate,
      vanityMaxCost,
    } = useSelector((state) => state.getEstimate);
    const {
      scheduledTimestamp,
      paymentMethodSelected,
      noOfDrivers,
      initialStates,
    } = useSelector((state) => state.deliveryDetails);
    const { appSetting, showPrice } = useSelector((state) => state.common);

    const { IsRetainerPartner, RetainerPartnerDeliveryWindow } = appSetting.PartnerLocationSettings;

    const showDeliveryCost = () => {
        const {ItemsToDeliver} = initialStates;
        const palletWhichHasVanity = ItemsToDeliver.filter(data => data.isVanity);

        //if selected pallets are odd number of pallets and all of then has vanity checkbox checked then show max price otherwise show min price.
        const calculatedCost = (isMuscleHelpRequired && tripType % 2 !== 0 && palletWhichHasVanity.length === tripType)
            ? currencyUtils.formatCurrency(vanityMaxCost)
            : estimate;
        
        return appSetting.PartnerLocationSettings?.EstimatePageFields[0]?.IsPartnerUpcharge
            ? partnerUpchargeValue.split("-")[0]
            : calculatedCost;
    };

    const getWhatsNeededSummary = () => {
        const { UIType, SoloSummarysectionvalue, DuoSummarysectionvalue } = whatsNeededData;
        if (isMuscleHelpRequired) {
            return showNumberOfDrivers(initialStates, tripType);
        }
        if (UIType === WhatsNeededUIType.PALLETS) {
            return `${tripType} ${PALLET_LABEL}${pluralSuffix(tripType > SOLO)}`;
        }
        return noOfDrivers === SOLO
            ? SoloSummarysectionvalue
            : DuoSummarysectionvalue;
    };

    return (
        <React.Fragment>
            <div className="summary-container grey">
                <h2 className="summary-label">
                    Summary{" "}
                    <span className="edit-label" onClick={editBungii}>
                        EDIT
                    </span>
                </h2>
                {state.isVisibleSoloDuo && (
                    <div>
                        <label>What’s needed:</label>
                        <p>{getWhatsNeededSummary()}</p>
                    </div>
                )}
                <div>
                    <label>Pickup Address:</label>
                    <p>{pickupAdd}</p>
                </div>
                <div>
                    <label>Delivery Address:</label>
                    <p>{dropoffAdd}</p>
                </div>
                {state.serviceName && (
                    <div>
                        <label>Service Level:</label>
                        <p>
                            {state.serviceName +
                                " - " +
                                state.serviceDescription}
                        </p>
                    </div>
                )}
                <div>
                    <label>Pickup Date &amp; Time:</label>
                    <p>{scheduledTimestamp}</p>
                </div>
                
                <div>
                    <label>Estimated Delivery Time:</label>
                    <p>{IsRetainerPartner ? RetainerPartnerDeliveryWindow : deliveryTime}</p>
                </div>
                <div>
                    <label>Distance:</label>
                    <p>{distance} miles</p>
                </div>
                <div>
                    <label>Payment:</label>
                    {paymentMethodSelected === "MI" && (
                        <p>This will be included on your invoice.</p>
                    )}
                    {paymentMethodSelected === "CC" && <p>Customer Card</p>}
                    {paymentMethodSelected === "PC" && <p>Partner Pay</p>}
                </div>
                <div>
                    <h2 className="estimate-label">
                    {globalConstants.PageLabels.DeliveryCost}
                        <span>
                            <strong>
                                {showPrice
                                    ? showDeliveryCost() 
                                    : languageConstants.defaultPrice.bestBuy}
                            </strong>
                        </span>
                    </h2>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Summary;